import type { ReactNode, Ref } from 'react';

type ToolbarFormatGroupProps = {
  children?: ReactNode;
  ref?: Ref<HTMLDivElement>;
};

export function ToolbarFormatGroup({ children, ref }: ToolbarFormatGroupProps) {
  return (
    <div className="ql-format-group" ref={ref}>
      {children}
    </div>
  );
}
ToolbarFormatGroup.displayName = 'RichTextEditor_ToolbarFormatGroup';
